<app-top-bar></app-top-bar>
<app-movies-section></app-movies-section>
